import { NodeAPI } from '@platform/shared/rpc';
import type { Ref } from 'vue';
import { toRaw } from 'vue';
import { AuthRoutines } from '@platform/store';
import user_config from '@platform/components/user_config';
import config from '@platform/shared/config';
import type { LoginDto } from '@platform/shared/rpc/node/api.gen';

export async function authLogin(
    loginData: LoginDto,
    {
        loginError,
    }: {
        loginError?: Ref<string | null>;
    }
) {
    const { access_token, ...loginResult } = await NodeAPI.AuthService.login(
        {
            body: toRaw(loginData),
        },
        { isAuthRequest: true } as any
    );
    const query_response = {
        id_token: 'fake-token_development-environment',
    };
    if (loginError) loginError.value = null;
    AuthRoutines.onLoad(query_response.id_token, access_token);
    loginResult.id_token = query_response.id_token;
    const orgInfo = await user_config.executeLoginRoutines(loginResult, loginData.login);
    user_config.guest.value = null;

    // @ts-ignore
    if (window.ym && config.metrikaId) {
        window.ym(config.metrikaId, 'userParams', {
            UserID: loginResult.id || null,
            Username: loginResult.login || null,
            Org: orgInfo?.mainOrgName || null,
        });
    }
}

export type AuthLoginCallback = typeof authLogin;
